/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Favorites_Meta_DescriptionInputs */

const en_favorites_meta_description = /** @type {(inputs: Favorites_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your saved image prompts.`)
};

const es_favorites_meta_description = /** @type {(inputs: Favorites_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus prompts de imagen guardados.`)
};

/**
* | output |
* | --- |
* | "Your saved image prompts." |
*
* @param {Favorites_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const favorites_meta_description = /** @type {((inputs?: Favorites_Meta_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favorites_Meta_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_favorites_meta_description(inputs)
	return es_favorites_meta_description(inputs)
});